<template>
  <div>
    <modal size="md" modal-id="signature-modal" show-on-mount :title="modalTitle" @closed="$emit('modal-closed')">
      <template #body>
        <template v-if="petition.successful">
          <success-banner />
          <hr class="my-4">
        </template>

        <sign-petition />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/modal'
import SignPetition from './sign-petition'
import SuccessBanner from './success-banner'

export default {
  components: { Modal, SignPetition, SuccessBanner },

  emits: ['modal-closed'],

  computed: {
    ...mapState(['petition', 'signTitle']),

    modalTitle() {
      if (this.petition.signersWriteToDecisionMaker) {
        return this.i18n.t('public.petitions.write_to_target.send_a_message')
      } else {
        return this.signTitle
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Avoid extending the line beyond the modal's body
::v-deep(.hr-full-width) {
  margin-left: -20px;
  margin-right: -20px;
}

::v-deep(.modal-header) {
  align-items: center;
}

.large-close {
  border-radius: 50%;
  border: 1px solid black;
  box-shadow: 0 5px 10px #0003;
  width: 2em;
  height: 2em;
  font-size: 1.1em;
  color: #000000;
  padding: {
    right: unset;
    left: unset;
  }
}
</style>
